import React from "react";
import { generalIcons } from "../../utils/constants";
import { SubPageSectionHeading } from "../../components";

const KeyBenefits = () => {
  return (
    <section className="relative py-6 lg:py-12">
      <div className="max-w-[858px] mx-auto text-center">
        <SubPageSectionHeading className="mb-4 lg:mb-[34px]">
          Key benefits for users
        </SubPageSectionHeading>

        <div className="space-y-4 flex flex-col items-center">
          <div className="flex  justify-center gap-2 w-fit">
            <span className="size-7 min-w-7 *:size-full">{generalIcons.coin2}</span>
            <h4 className="text-sm/6 -tracking-[0.8px] font-medium font-serif text-gunMetal mb-0">
              Access $VANRY natively on the Vanar blockchain without needing
              centralized exchanges.
            </h4>
          </div>
          <div className="flex  justify-center gap-2 w-fit">
            <span className="size-7  min-w-7 *:size-full">{generalIcons.coin2}</span>
            <h4 className="text-sm/6 -tracking-[0.8px] font-medium font-serif text-gunMetal mb-0">
            Diversify holdings and participate in the Vanar ecosystem more easily.
            </h4>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyBenefits;
